import axios from 'axios'
import endpoints from './endpoints'

/**
 * 获取 JSSDK
 */
const fetchWeChatJSSDKConf = async (params) => {
  try {
    const url = endpoints.WechatJSSdkConf
    const {data} = await axios.get(url, {
      params,
    })

    return data
  }
  catch (error) {
    //
    console.error(error)

    //
    throw new Error('Error: within fetchWeChatJSSDKConf()')
  }
}

export {fetchWeChatJSSDKConf}
